import React, {useEffect, useState} from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {currencyFormat} from "../../../utils/masks";
import {RiArrowUpDownFill} from "react-icons/ri";
import {getReport} from "../../../services/Trading";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {
    StrategyEmptyState,
    StrategyLoadingButton,
} from "../../../pages/Strategy/styles";
import {OpsMeta, ReportTradingTableWrap, ReportTradingTableContainer} from "./styles";

const sortHeadStyle = {
    cursor: 'pointer',
    userSelect: 'none',
};

const sortIconStyle = {
    verticalAlign: 'middle',
    marginLeft: 6,
    color: '#f29205',
    opacity: 0.95,
};

export default function ReportTrading({filter}) {
    const [loading, setLoading] = useState(true);
    const [orderBy, setOrderBy] = useState('profitObtained');
    const [order, setOrder] = useState('DESC');
    const [list, setList] = useState([]);
    const {coinType} = useSelector((state) => state.BankReducer);
    const { t } = useTranslation();

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        getReport({
            startDate: filter[0].startDate,
            endDate: filter[0].endDate,
            orderBy: orderBy,
            order: order
        }).then((data) => {
            if (cancelled) {
                return;
            }
            setLoading(false);
            if (!data || data === '' || !data.data) {
                setList([]);
                return;
            }

            setList(data.data.tradings || []);
        });

        return function cleanup() {
            cancelled = true;
        };
    }, [orderBy, order, filter]);

    const renderProfitCell = (profitObtained) => {
        const v = parseFloat(profitObtained);
        const text = `${coinType} ${currencyFormat(v)}`;
        if (v > 0) {
            return <span style={{color: '#5bd37c', fontWeight: 700}}>{text}</span>;
        }
        if (v < 0) {
            return <span style={{color: '#ff8a8a', fontWeight: 700}}>{text}</span>;
        }
        return <span style={{fontWeight: 700}}>{text}</span>;
    };

    return (
        <ReportTradingTableWrap>
            {loading ? (
                <StrategyLoadingButton
                    className="btn btn-primary text-capitalize font-weight-bold"
                    loading={loading}
                    type="button"
                >
                    {t('loading')}
                </StrategyLoadingButton>
            ) : (
                <>
                    {list && list.length ? (
                        <ReportTradingTableContainer>
                            <Table aria-label={t('traging_report_title')}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            align="center"
                                            style={sortHeadStyle}
                                            onClick={() => {
                                                setOrderBy('currencyPair');
                                                setOrder(order === 'DESC' ? 'ASC' : 'DESC');
                                            }}
                                        >
                                            {t('traging_report_table_col_currency_pair')}{' '}
                                            <RiArrowUpDownFill style={sortIconStyle}/>
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={sortHeadStyle}
                                            onClick={() => {
                                                setOrderBy('count');
                                                setOrder(order === 'DESC' ? 'ASC' : 'DESC');
                                            }}
                                        >
                                            {t('traging_report_table_col_operations')}{' '}
                                            <RiArrowUpDownFill style={sortIconStyle}/>
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={sortHeadStyle}
                                            onClick={() => {
                                                setOrderBy('investmentValue');
                                                setOrder(order === 'DESC' ? 'ASC' : 'DESC');
                                            }}
                                        >
                                            {t('traging_report_table_col_total')}{' '}
                                            <RiArrowUpDownFill style={sortIconStyle}/>
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={sortHeadStyle}
                                            onClick={() => {
                                                setOrderBy('profitObtained');
                                                setOrder(order === 'DESC' ? 'ASC' : 'DESC');
                                            }}
                                        >
                                            {t('traging_report_table_col_profit_prejudice')}{' '}
                                            <RiArrowUpDownFill style={sortIconStyle}/>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {list.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell align="center">{row.currencyPair}</TableCell>
                                            <TableCell align="center">
                                                {t('trading_report_ops_count', { count: row.count })}
                                                <OpsMeta>
                                                    {row.qtdeWin} {t('victories')} / {row.qtdeDraw} {t('draws')} / {row.qtdeLoss} {t('defeats')}
                                                </OpsMeta>
                                            </TableCell>
                                            <TableCell align="center">
                                                {coinType} {currencyFormat(parseFloat(row.investmentValue))}
                                            </TableCell>
                                            <TableCell align="center">
                                                {renderProfitCell(row.profitObtained)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </ReportTradingTableContainer>
                    ) : (
                        <StrategyEmptyState>
                            <i className="far fa-file-alt" aria-hidden="true"/>
                            <p>{t('trading_empty_title')}</p>
                            <span>{t('trading_empty_subtitle')}</span>
                        </StrategyEmptyState>
                    )}
                </>
            )}
        </ReportTradingTableWrap>
    );
}
